/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { Field } from "formik";
import { EditComponentProps } from "material-table";
import { Button, makeStyles, Theme, createStyles } from "@material-ui/core";
import {
  PlainSelect,
  PlainSelectDef,
  ConfigDialog,
} from "../../../../../components";
import { FileCrawlingConfigDataRow } from "../../../../../types/config";
import { ConnectionsApi } from "../../../../../helpers";
import { ConnectionConfigContent } from "../../../connection/ConnectionConfigContent";
import { OptionData } from "../../../../../types";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pulldown: {
      width: "10rem",
    },
    configDialogOpenButton: {
      marginTop: "1rem",
      color: theme.palette.text.secondary,
    },
  })
);

interface Props extends EditComponentProps<FileCrawlingConfigDataRow> {
  autoFocus?: boolean;
  onError?: (error: any) => void;
}

/** 接続先設定編集コンポーネント */
export function ConnectionEditComponent(props: Props) {
  const classes = useStyles();

  const { value: fieldValue, autoFocus, onError } = props;

  const calculatedValue =
    Object.keys(fieldValue).length === 0 ? { name: "", value: "" } : fieldValue;

  // 接続先
  // モーダル
  const [open, setOpen] = React.useState<boolean>(false);
  // 選択肢
  const [connectionOptions, setConnectionOptions] = React.useState<
    OptionData[]
  >([]);

  const updateConnectionOptions = (cleanedUp: boolean) => {
    const fetchData = async () => {
      try {
        const res: any = await ConnectionsApi.list();
        const optionData = res.data.map((row: any) => ({
          name: `${row.name} (${row.host})`,
          value: String(row.id),
        }));
        if (!cleanedUp) {
          setConnectionOptions(optionData);
        }
      } catch (error: any) {
        if (onError) {
          if (!cleanedUp) {
            onError(error);
          }
        }
      }
    };
    fetchData();
  };

  // 初回のみ
  React.useEffect(() => {
    let cleanedUp = false;

    updateConnectionOptions(cleanedUp);

    return function cleanup() {
      cleanedUp = true;
    };
  }, []);

  // 接続先設定モーダル閉じたとき
  React.useEffect(() => {
    let cleanedUp = false;

    if (!open) {
      updateConnectionOptions(cleanedUp);
    }

    return function cleanup() {
      cleanedUp = true;
    };
  }, [open]);

  //--------------------
  // コンポーネント
  return (
    // eslint-disable-next-line react/destructuring-assignment
    <Field name={props.columnDef.field}>
      {(args: any) => {
        const { field, form } = args;
        const { name } = field;
        const { errors, touched, setFieldValue } = form;

        // onChange, onBlur, name and value は
        // name で引き当てて HtmlのReactコンポーネントに自動注入するが、
        // 上手くnameを設定すればいけるかもしれないが、
        // フォーカスアウト時にはtouchedにできていない。
        // それでも、適用ボタンを押下時にtouchedになるのでそれで良しとする。

        return (
          <>
            {/*
              接続先

            */}
            <PlainSelect
              {...props}
              {...field}
              id="id_connection"
              label="接続先"
              data={calculatedValue.value}
              defs={connectionOptions}
              handleChange={(event: React.ChangeEvent<any>) => {
                const { value: eValue } = event.target;
                if (typeof eValue === "string") {
                  const selectedConnection = connectionOptions.find(
                    (def: PlainSelectDef) => def.value === eValue
                  );
                  if (selectedConnection) {
                    const newConnection = {
                      name: selectedConnection.name,
                      value: eValue,
                    };
                    props.onChange(newConnection); // for MaterialTable
                    setFieldValue(name, newConnection); // for Formik
                  }
                }
              }}
              error={touched[name] && errors[name]}
              helperText={touched[name] && errors[name]}
              autoFocus={autoFocus}
              className={classes.pulldown}
            />
            <div style={{ marginTop: "0.5rem" }}>
              <Button
                className={classes.configDialogOpenButton}
                size="small"
                onClick={() => {
                  setOpen(true);
                }}
              >
                接続先設定
              </Button>
              <ConfigDialog
                open={open}
                title="接続先設定"
                okLabel="閉じる"
                handleClose={() => {
                  setOpen(false);
                }}
              >
                <div style={{ minWidth: 800 }}>
                  <ConnectionConfigContent onError={onError} />
                </div>
              </ConfigDialog>
            </div>
          </>
        );
      }}
    </Field>
  );
}
